import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '@morningstar/shared/base/base-service';
import { KeyValuePair } from '@morningstar/shared/models';
import { SystemParameters } from '../system-parameters/system-parameters';
import { PeriodsSelectors } from './periods.selectors';

@Injectable()
export class PeriodService extends ApiService {

  dataDescription = 'period';

  constructor(protected httpClient: HttpClient,
              @Inject('API_BASE_URL') protected baseUrl: string,
              protected snackbar: MatSnackBar) {
    super(httpClient, baseUrl, snackbar);
  }

  getPeriods() {
    const endpoint = 'periods';

    this.readList(PeriodsSelectors.periods, endpoint).subscribe();
  }

  getInvoicePeriods() {
    const endpoint = 'periods/invoice';
    this.readList(PeriodsSelectors.periods, endpoint).subscribe();
  }

  getInvoicePeriodsObservable() {
    const endpoint = 'periods/invoice';
    return this.readList(PeriodsSelectors.periods, endpoint);
  }

  getInvoiceVoidPeriods(location: string) {
    const endpoint = 'periods/invoice-voids/{location}';
    const params = [ new KeyValuePair('{location}', location) ];

    this.readList(PeriodsSelectors.periods, endpoint, null, params).subscribe();
  }

  getSystemParameters() {
    this.read<SystemParameters>(PeriodsSelectors.systemParameters, 'system-parameters').subscribe();
  }
}
